import DealsPage from "@/components/pages/inventory/deals";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/inventory/deals/_modal/")({
	component: DealsPage,
});
